/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Status_PendingInputs */

const en_team_status_pending = /** @type {(inputs: Team_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending`)
};

const es_team_status_pending = /** @type {(inputs: Team_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendiente`)
};

const fr_team_status_pending = /** @type {(inputs: Team_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En attente`)
};

const de_team_status_pending = /** @type {(inputs: Team_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausstehend`)
};

const id_team_status_pending = /** @type {(inputs: Team_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tertunda`)
};

/** @type {(inputs: Team_Status_PendingInputs) => LocalizedString} */
const ja_team_status_pending = en_team_status_pending;

/** @type {(inputs: Team_Status_PendingInputs) => LocalizedString} */
const zh_team_status_pending = en_team_status_pending;

/** @type {(inputs: Team_Status_PendingInputs) => LocalizedString} */
const ar_team_status_pending = en_team_status_pending;

/** @type {(inputs: Team_Status_PendingInputs) => LocalizedString} */
const it_team_status_pending = en_team_status_pending;

/** @type {(inputs: Team_Status_PendingInputs) => LocalizedString} */
const ru_team_status_pending = en_team_status_pending;

/** @type {(inputs: Team_Status_PendingInputs) => LocalizedString} */
const pt_team_status_pending = en_team_status_pending;

/** @type {(inputs: Team_Status_PendingInputs) => LocalizedString} */
const ko_team_status_pending = en_team_status_pending;

/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Team_Status_PendingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_status_pending = /** @type {((inputs?: Team_Status_PendingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Status_PendingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_status_pending(inputs)
	if (locale === "es") return es_team_status_pending(inputs)
	if (locale === "fr") return fr_team_status_pending(inputs)
	if (locale === "de") return de_team_status_pending(inputs)
	if (locale === "ja") return ja_team_status_pending(inputs)
	if (locale === "zh") return zh_team_status_pending(inputs)
	if (locale === "ar") return ar_team_status_pending(inputs)
	if (locale === "id") return id_team_status_pending(inputs)
	if (locale === "it") return it_team_status_pending(inputs)
	if (locale === "ru") return ru_team_status_pending(inputs)
	if (locale === "pt") return pt_team_status_pending(inputs)
	return ko_team_status_pending(inputs)
});